import React from "react";
import { useSelector } from "react-redux";
import { selectAdminUuid } from "./authSlice";
import { Navigate, Outlet } from "react-router-dom";

export default function AuthRequired() {
  if (useSelector(selectAdminUuid)) {
    return <Outlet />;
  } else {
    return <Navigate to={"login"} />;
  }
}
